import React, { useState } from 'react';
import {
  useStripe,
  useElements,
  PaymentElement
} from '@stripe/react-stripe-js';
import Button from '../common/button';
import green from '@mui/material/colors/green';

const CheckoutForm = (props) => {
  const stripe = useStripe();
  const elements = useElements();

  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (ev) => {
    ev.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setLoading(true);
    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: 'https://udlejer.akutbolig.dk/dwellings'
      }
    });
    setLoading(false);

    if (error) {
      setErrorMessage(error.message);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <Button
        style={{
          marginTop: '20px',
          backgroundColor: green[500],
          color: '#fff'
        }}
        type="submit"
        fullWidth
        disabled={loading}
        variant="contained"
        label={props.amount ? `Betal ${props.amount / 100} DKK` : 'Betal'}
      />
      {errorMessage ? (
        <div style={{ color: 'red', marginTop: 12 }}>{errorMessage}</div>
      ) : null}
    </form>
  );
};

export default CheckoutForm;